export default __webpack_public_path__ + "static/media/no_permission.e0ff94ae.png";